import { Alert } from "@mui/material";

import { useAccountSite } from "@/api/siteDetails";
import { useSiteNavigation } from "@/hooks/useSiteNavigation";

export const TEST_MODE_BANNER_MESSAGE =
  "Test Mode is enabled. Emails and texts won't send until test mode is disabled. Disable test mode in Settings when ready to go live.";

export function TestModeBanner() {
  const { siteIdFromParams } = useSiteNavigation();
  const { data: site } = useAccountSite(siteIdFromParams ?? "");

  if (!site?.test_mode) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      data-testid="test-mode-banner"
      sx={{
        borderRadius: 0,
        justifyContent: "center",
        "& .MuiAlert-message": { flex: "unset", textAlign: "center" },
      }}
    >
      {TEST_MODE_BANNER_MESSAGE}
    </Alert>
  );
}
